import { useEffect } from 'react';
import LegalPage from '@/components/LegalPage';
import { privacyPolicySV, privacyPolicyEN } from '@/data/legal/privacy-policy';

export default function PrivacyPage() {
  useEffect(() => {
    document.title = 'Integritetspolicy - Beredskapshubben';
  }, []);

  return (
    <LegalPage 
      titleSV="Integritetspolicy"
      titleEN="Privacy Policy"
      contentSV={privacyPolicySV}
      contentEN={privacyPolicyEN}
    />
  );
}
